import React from 'react'

const ProExp = () => {
    return (
        <div className='pick'>
            <h2 className='h2Title'>Professional Experience</h2>

            <h3 className='ExpTitle'>Front Desk Clerk and Laundry
                <p>
                   at Super 8 Motel in Rexburg Idaho from April 2018 to June 2020
                </p>
            </h3>

            <h3 className='ExpTitle'>Assistant to the Director of Education
                <p>
                    at the Rexburg College of Massage Therapy in Rexburg Idaho from October 2017 to June 2020
                </p>
            </h3>

            <h3 className='ExpTitle'>
                Apartment Cleaner
                <p>
                    at the Nauvoo House from December 2017 to December 2019 and The Pines housing from December 2019 to April 2020 in Rexburg Idaho
                </p> 
            </h3>
            <h3 className='ExpTitle'>
                Warehouse production worker 
                <p>
                    at Deseret Industries in Rexburg Idaho from October 2016 to February 2018
                </p>
            </h3>
        </div>
    )
}

export default ProExp